import {SessionActivityName} from './session';

export enum LiveHelpMode {
    Popup = 'popup',
    IFrame = 'iframe',
    Widget = 'widget'
}

export enum LiveHelpPosition {
    Inline = 'inline',
    RightTop = 'right-top',
    RightBottom = 'right-bottom',
    LeftTop = 'left-top',
    LeftBottom = 'left-bottom'
}

export type LiveHelpOptions = {
    classList: string;
    mode: LiveHelpMode;
    iframe: string;
    conversationOnly: boolean;
    position: LiveHelpPosition;
    container: string;
    iconUrl: string;
    renderOnInit: boolean;
    styled: boolean;
    onLoad: string;
    selfieValidationCallback: string;
    defaultActivity: SessionActivityName;
    activitiesSelection: SessionActivityName[];
    appointment: {
        pin: string;
        code: string;
    }
}